import { render, staticRenderFns } from "./AdminLnb.vue?vue&type=template&id=cb791b1e"
import script from "./AdminLnb.vue?vue&type=script&lang=js"
export * from "./AdminLnb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports